// API resources
import apiFormQuestionnaire from '@/api/modules/form-questionnaire.js'

// Mutations
import { RESET_MODULE, ADD_FORM_QUESTIONNAIRE } from '@/store/mutation-types'


// Default state
const getDefaultState = () => {
  return {
    config: [],
    answers: {}
  }
}
const state = getDefaultState()

// ----------------------------------------------------------------------

const actions = {
  fetchRiskQuestionnaire ({ commit }) {
    return apiFormQuestionnaire.fetchFormQuestionnaire('profil')
      .then(data => {
        commit(ADD_FORM_QUESTIONNAIRE, data.form)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },

  fetchAnswersRisk ({ commit }, { payload, customerId }) {
    return apiFormQuestionnaire.fetchAnswersRisk('profil', payload, customerId)
      .then(data => {
        return data
      })
      .catch((err) => {
        return Promise.reject(err)
      })
  },

  resetState (context) {
    context.commit(RESET_MODULE)
  }
}

const mutations = {
  [ADD_FORM_QUESTIONNAIRE] (state, data) {
    state.config = data
  },

  [RESET_MODULE] (state) {
    Object.assign(state, getDefaultState())
  }
}

export default () => ({
  namespaced: true,
  state,
  actions,
  mutations
})
